import TranslationService from "@/shared/services/translation.service";
import { Component, Inject, Mixins, Vue } from "vue-property-decorator";
import GlobalService from "../services/global.service";
import Currencies from "@/shared/constants/currencies.constants";
import { IUserUI } from "@/shared/model/userUI.model";
import { IYmlConstants } from "@/shared/model/global/yml-constants.model";
import UtilityMixin from "./utility-mixin";
import { Paths } from "../constants/paths.constants";

@Component
class GlobalMixin extends Mixins(UtilityMixin) {
  @Inject("globalService") public globalService: () => GlobalService;
  @Inject("translationService") public translationService: () => TranslationService;

  public captchaValidated: boolean = null;
  public gameType; // which questionnaire
  public user: IUserUI;

  public initTranslation(){
    this.translationService().initTranslateLanguage()
  }

  public changeLanguage(newLanguage: string): void {
    this.translationService().refreshTranslation(newLanguage);
  }

  public changeCurrency(newCurrency) {
    this.translationService().refreshCurrency(newCurrency);
  }

  public get currency() {
    let currency = this.$store.getters.currency;
    let display = Object.values(Currencies).find((el) => el.value == currency).display;
    return display;
  }

  public deleteCookieAndCreateOnePlusgtag(cookieOptionalAccepted) {
    let cookieName = "cookie_choice_opt";
    let choice = this.$cookies.get(cookieName);
    if (choice !== undefined) this.$cookies.remove(cookieName);

    let consent = {
      ad_storage: "granted",
      analytics_storage: "granted",
      functionality_storage: "granted",
      security_storage: "granted",
    };
    if (!cookieOptionalAccepted) {
      consent = {
        ad_storage: "denied",
        analytics_storage: "denied",
        functionality_storage: "granted",
        security_storage: "granted",
      };
    }
    this.$cookies.set("cookie_choice_opt", consent, 60 * 60 * 24 * 30 * 2);
    this.startGtagTracking(consent);
  }

  public get onElearning() {
    let path = sessionStorage.getItem("path");
    if (path.indexOf(Paths.ODO_SELF_ASSESSMENT) > -1) return true;
    else return false;
  }

  public onCaptchaExpired(event) {
    this.captchaValidated = false;
  }

  public onCaptchaVerified(event) {
    this.globalService()
      .postRecaptcha(event)
      .then((res) => {
        this.captchaValidated = true;
      })
      .catch((error) => {
        console.log("Update in error: " + error);
      });
  }

  /*
   * consider each step as a page and send page view on questionnaires
   */
  public sendPageView(title) {
    if (process.env.NODE_ENV == "development" || this.$store.getters.activeProfiles.indexOf("test") > -1 || this.$store.getters.activeProfiles.indexOf("preprod") > -1) return;

    let dataLayer = window["dataLayer"];
    dataLayer.push({ event: "odo.pageView", "odo.pageTitle": title, "odo.pagePath": this.$route.path });
  }

  // sending GTM event
  public sendCustomEvent(type) {
    // send odonatech customized for google analytics
    if (process.env.NODE_ENV == "development" || this.$store.getters.activeProfiles.indexOf("test") > -1 || this.$store.getters.activeProfiles.indexOf("preprod") > -1) return;
    // deactivate "diversico.*" events (temporarily?)
    if (type.startsWith("Diversico.")) return;

    this.sendDataLayerEventOdoClick(type, false);
  }

  public async startGtagTracking(object) {
    // start google analytics tracking, after click on cookie banner or if already accepted
    if (process.env.NODE_ENV == "development" || this.$store.getters.activeProfiles.indexOf("test") > -1 || this.$store.getters.activeProfiles.indexOf("preprod") > -1) return;

    // update GTM consent
    let gtag = window["gtag"];
    gtag("consent", "update", object);
  }

  // sending GTM event for diversico (sds, sdsnf, chocoswipe)
  public sendDataLayerEventSds(type, object) {
    if (process.env.NODE_ENV == "development" || this.$store.getters.activeProfiles.indexOf("test") > -1 || this.$store.getters.activeProfiles.indexOf("preprod") > -1) return;
    // only for diversico social sequences
    const sequence = this.$route.params.sequence;
    if (sequence != "sds" && sequence != "sdsnf") return;

    let dataLayer = window["dataLayer"];
    if (object == null) {
      dataLayer.push({ event: "sds.click", "sds.elementId": type });
    } else {
      dataLayer.push({ event: "sds." + type.replaceAll("-", "."), "sds.result": object });
    }
  }

  public sendDataLayerEventOdoClick(type, isFacettes) {
    if (process.env.NODE_ENV == "development" || this.$store.getters.activeProfiles.indexOf("test") > -1 || this.$store.getters.activeProfiles.indexOf("preprod") > -1) return;

    let dataLayer = window["dataLayer"];
    const facetteTxt = isFacettes ? "facettes_" : "";
    dataLayer.push({ event: "odo.click", "odo.elementId": facetteTxt + type });
  }

  /*
   * get some conf parameters (in yml) from backend
   */
  public async setYmlConstants() {
    try {
      let constants: IYmlConstants = await this.globalService().getYmlConstants();
      this.$store.commit("setYmlConstants", constants);
    } catch (error) {
      throw error;
    }
  }
}
export default GlobalMixin;
